@if ((groupedDealCompanies$ | async); as data) {
  @if (data.length > 0) {
    <div class="chart-container">
      <canvas #dealsTreemap id="dealsTreemap"></canvas>
    </div>
  } @else {
    <div class="detail-card-content" style="color: grey">
      For displaying the companies treemap, you need to add some data first.
    </div>
  }
  @if (filteredData.length > 0 && missingGpNAVAssets.length > 0) {
    <valumize-info-panel
      appearance="WARNING"
      [message]="'The treemap is incomplete because the following assets are missing the GP NAV: ' + missingGpNAVAssets.join(', ')">
    </valumize-info-panel>
  }
}
